if (!customElements.get('adelaide-mobile-sort')) {
  customElements.define('adelaide-mobile-sort', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', event => {
        // External form controls are included in FormData but do not bubble
        // input events through the form. Notify Dawn's existing handler.
        event.target.form?.dispatchEvent(new Event('input', { bubbles: true }));
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
